import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  SxProps,
  Typography
} from '@mui/material';
import { Button } from 'system/atoms';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { successModalAtom } from 'services/modals/atoms';
import { useSuccessModal } from 'services/modals/hooks';

const titleContainer: SxProps = {
  mb: 3
};

const buttonsContainer: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  mt: 3
};

const contentContainer: SxProps = {
  maxWidth: 400
};

export const SuccessModal = () => {
  const { isOpen, title, subtitle, onConfirm } =
    useRecoilValue(successModalAtom);

  const { closeModal } = useSuccessModal();

  const handleConfirm = () => {
    onConfirm?.();
    closeModal();
  };

  return (
    <Dialog open={isOpen} onClose={closeModal}>
      <DialogContent sx={contentContainer}>
        <Typography variant="h6" fontWeight="bold" sx={titleContainer}>
          {title}
        </Typography>
        <DialogContentText>{subtitle}</DialogContentText>

        <Box sx={buttonsContainer}>
          <Button onClick={handleConfirm} variant="primary" fullWidth>
            Ok
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
